module.exports = __webpack_public_path__ + "static/Pluto-b36772a58dbea2d9a5c82e170db73ef1.jpg";